import { Redirect, Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import React from 'react';

import * as path from '../../../util/pathConstructor';

import PromptContainer from '../../prompt/promptContainer';

const mapStateToProps = (state) => {
    return {
        assessment: state.app.assessment,
        promptQueue: state.session.promptQueue
    };
};

class ProtectedRoute extends React.Component {
    constructor(props) {
        super(props);
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.promptQueue === nextProps.promptQueue) {
            return false;
        } else {
            return true;
        }
    }

    isValidEntryPoint() {
        let valid = true;

        if (this.props.promptQueue.length > 0) {
            const promptId = this.props.computedMatch.params.promptId;
            valid = this.props.promptQueue.includes(promptId);
        }

        return valid;
    }

    getRedirectPath() {
        const { assessment, match: {params}, location } = this.props;
        const assessmentName = params.assessmentName;
        const rootPromptId = assessment.rootPrompt;

        return path.getPromptPath(assessmentName, location.search, rootPromptId);
    }

    render() {
        return (
            <Route path={this.props.path} exact={this.props.exact} render={(props) => (
                !(this.isValidEntryPoint()) ? (
                    <Redirect to={this.getRedirectPath()} />
                ) : (
                    <PromptContainer {...props} />
                    )
            )} />
        )
    }
};

export default withRouter(connect(mapStateToProps, null)(ProtectedRoute));